// Gera o XLSX do relatório de atendimentos (mesma planilha de antes, agora
// com as colunas escolhidas no modal Exportar e transcrição opcional).
import * as XLSX from "xlsx";
import { buildExportRows } from "./reportRules";
import { i18n } from "../../translate/i18n";

const t = (k, o) => i18n.t(`aeros.reports.${k}`, o);
const br = (s) => (s ? s.split("-").reverse().join("/") : t("notInformed"));

export default function exportXlsx({ tickets, columns, dateFrom, dateTo, transcripts }) {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([
    [t("sheetTitle")],
    [`${t("sheetStart")}: ${br(dateFrom)}`],
    [`${t("sheetEnd")}: ${br(dateTo)}`],
    [],
    columns.map((c) => c.label),
    ...buildExportRows(tickets, columns),
  ]);
  ws["!merges"] = [{ s: { c: 0, r: 0 }, e: { c: Math.max(columns.length - 1, 1), r: 0 } }];
  ws["!cols"] = columns.map((c) => ({ wch: c.width || 15 }));
  ws["!rows"] = [{ hpt: 25 }, { hpt: 20 }, { hpt: 20 }, { hpt: 10 }, { hpt: 25 }];
  const range = XLSX.utils.decode_range(ws["!ref"]);
  for (let r = 0; r <= 4; r++) {
    for (let c = range.s.c; c <= range.e.c; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r, c })];
      if (!cell) continue;
      if (r === 0) cell.s = { font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } }, fill: { fgColor: { rgb: "4472C4" } }, alignment: { horizontal: "center", vertical: "center" } };
      else if (r === 1 || r === 2) cell.s = { font: { bold: true, sz: 12 }, fill: { fgColor: { rgb: "E7E6E6" } } };
      else if (r === 4) cell.s = { font: { bold: true, color: { rgb: "FFFFFF" } }, fill: { fgColor: { rgb: "70AD47" } }, alignment: { horizontal: "center", vertical: "center" } };
    }
  }
  XLSX.utils.book_append_sheet(wb, ws, t("sheetTickets"));

  if (transcripts && transcripts.length) {
    const rows = [["ticket", "contact", "datetime", "from", "message"].map((k) => t(`transcript.${k}`))];
    transcripts.forEach(({ ticket, messages }) => {
      (messages || []).forEach((m) => {
        rows.push([ticket.id, ticket.contactName, new Date(m.createdAt).toLocaleString("pt-BR"), m.fromMe ? t("transcript.agent") : t("transcript.customer"), m.body || `[${m.mediaType}]`]);
      });
    });
    const ws2 = XLSX.utils.aoa_to_sheet(rows);
    ws2["!cols"] = [{ wch: 8 }, { wch: 25 }, { wch: 18 }, { wch: 10 }, { wch: 80 }];
    XLSX.utils.book_append_sheet(wb, ws2, t("sheetChats"));
  }

  XLSX.writeFile(wb, "relatorio-de-atendimentos.xlsx", { cellStyles: true, bookType: "xlsx" });
}
